import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-shipping-control',
  templateUrl: './shipping-control.component.html',
  styleUrls: ['./shipping-control.component.scss'],
})
export class ShippingControlPage implements OnInit {
  destroyed$ = new Subject<boolean>();
  translations: any;
  shippingForm: FormGroup | any;
  previousData: any;
  originalValues: any;

  constructor(
    translate: TranslateService,
    public modalController: ModalController,
    private fb: FormBuilder,
  ) {
    translate
      .get(['ACTIONS', 'STORE_MODULE', 'ERRORS', 'SUCCESS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));
  }

  ngOnInit() {
    this.shippingForm = this.fb.group({
      addControl: [false],
      weight: ['', Validators.required],
      length: ['', Validators.required],
      width: ['', Validators.required],
      height: ['', Validators.required]
    });

    if(this.previousData){
      console.log('this.previousData: ', this.previousData);
      // this.shippingForm.patchValue({
      //   addControl: !this.previousData.unlimited,
      //   quantity: this.previousData.quantity
      // });
    }

    this.originalValues = this.shippingForm.value;

    this.shippingForm.get('addControl')?.valueChanges.subscribe((value) => {
      const quantityControl = this.shippingForm.get('quantity');

      if (value) {
        quantityControl?.addValidators(Validators.required);
      } else {
        quantityControl?.clearValidators();
      }
      quantityControl?.updateValueAndValidity();
    });
  }

  isFormValid(): boolean {
    return this.shippingForm.valid && this.shippingForm.dirty;
  }

  close() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  updateData(){
    if (this.isFormValid()) {
      console.log('Formulario actualizado:', this.shippingForm.value);
      this.originalValues = this.shippingForm.value; // Guardar nuevos valores
      this.shippingForm.markAsPristine(); // Resetear el estado dirty
      this.modalController.dismiss({
        value: this.shippingForm.value
      });
    }
  }

}
